module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGklEQVR4nGNYuHDhf0oww6gBowaMGjBcDAAA3tbiHyxEyr8AAAAASUVORK5CYII="